import { of } from "rxjs";
import { GraphQLService } from "./gqlService.js";
import { ServerResponseStatus } from "./types.js";
import { ValidationError } from "./ValidationError.js";
class EntityBaseGqlService {
  _service;
  _builder;
  constructor(client, builder, messageLocalizer) {
    this._service = new GraphQLService(client, messageLocalizer);
    this._builder = builder;
  }
  fetchData(requestPayload) {
    let gqlRequest;
    try {
      gqlRequest = this._builder.buildRequest(requestPayload);
    } catch (error) {
      const response = {
        status: ServerResponseStatus.Failed,
        requestPayload: null,
        responsePayload: {}
      };
      if (error instanceof ValidationError) {
        response.errors = [
          {
            severity: this.getErrorSeverity(error.code) ?? 0,
            code: error.code,
            message: error.message,
            values: []
          }
        ];
      } else {
        throw error;
      }
      return of(response);
    }
    return gqlRequest ? this._service.query(gqlRequest.query, gqlRequest.variables) : of({
      status: ServerResponseStatus.Success,
      requestPayload: gqlRequest,
      responsePayload: {}
    });
  }
}
export {
  EntityBaseGqlService
};
//# sourceMappingURL=EntityBaseGqlService.js.map
